import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ApiKey,
  ApiKeySpaceAccessRoleGrant,
  ApiKeysWithAccessToSpaceOutput,
  QueryApiKeysWithAccessToSpaceArgs,
  QueryApiKeysWithAccessToSpaceSuggestionsArgs,
  Role,
  SearchSuggestionsOutput,
  Space,
} from "types/generated";

type SpaceDetailsApiKeyGrantNode = Pick<ApiKeySpaceAccessRoleGrant, "propagated"> & {
  role: Pick<Role, "id" | "name" | "isSystem">;
  space: Pick<Space, "id" | "name">;
};

type SpaceDetailsApiKeyNode = {
  apiKey: Pick<ApiKey, "id" | "name">;
  roles: Array<SpaceDetailsApiKeyGrantNode>;
};

type ApiKeysWithAccessToSpaceData = {
  apiKeysWithAccessToSpace: {
    edges: Array<{ cursor: string; node: SpaceDetailsApiKeyNode }>;
    pageInfo: ApiKeysWithAccessToSpaceOutput["pageInfo"];
  };
};

export const API_KEYS_WITH_ACCESS_TO_SPACE: TypedDocumentNode<
  ApiKeysWithAccessToSpaceData,
  QueryApiKeysWithAccessToSpaceArgs
> = gql`
  query ApiKeysWithAccessToSpace($space: ID!, $input: SearchInput!) {
    apiKeysWithAccessToSpace(space: $space, input: $input) {
      edges {
        cursor
        node {
          apiKey {
            id
            name
          }
          roles {
            propagated
            role {
              id
              name
              isSystem
            }
            space {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type ApiKeysWithAccessToSpaceCountData = {
  apiKeysWithAccessToSpaceSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const API_KEYS_WITH_ACCESS_TO_SPACE_COUNT: TypedDocumentNode<
  ApiKeysWithAccessToSpaceCountData,
  QueryApiKeysWithAccessToSpaceSuggestionsArgs
> = gql`
  query ApiKeysWithAccessToSpaceCount($space: ID!, $input: SearchSuggestionsInput!) {
    apiKeysWithAccessToSpaceSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
